import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  templateAssignWrapper: {
    display: 'flex',
    alignSelf: 'center',
    width: '50%',
    paddingHorizontal: 20,
    marginTop: 20,
  },
  sectionHeader: {
    fontSize: 18,
    fontFamily: 'InterSemiBold',
    paddingBottom: 10,
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingBottom: 20,
    width: '100%',
  },
});

export default style;
